import InfoCardsV2 from "./Card/InfoCardsV2";
import NoGoAlert from "./Card/NoGoAlert";
import { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { CiUser } from "react-icons/ci";
import { AiOutlineStop } from "react-icons/ai";
import { LuShield } from "react-icons/lu";
import { RiFireLine } from "react-icons/ri";
import { FaHardHat, FaVest } from "react-icons/fa";
import { GiVest } from "react-icons/gi";
import { MdMonitor } from "react-icons/md";
import GateOpenAlert from "./Card/GateOpenAlert";
import FireAlert from "./Card/FireAlert";
import DashboardService from "../../../../api/dashboardService";
import { errorToast } from "../../../../_helper/helper";
import FactoryService from "../../../../api/factoryService";
import { getCurrentWeekWithYear } from "../../../../utils/currentWeekWithYear";
import { Loader3 } from "../../../../CommonElements/Spinner/loader";
import ModelAnalyticsHeader from "../GlobalFilterSE/ModelAnalytics";
import WeekFilterProvider from "../GlobalFilterSE/WeakGlobal";
import HouseKeeping from "./Card/HouseKeeping";
import Vest from "./Card/Vest";
import HelmetModule from "./Card/HelmetModule";
import AreaService from "../../../../api/areaService";

// Constants
const FILTER_STORAGE_KEY = 'liveAnalyticsFilters';

// Category mapping for API response
const CATEGORY_MAPPING = {
    'No_Go_Area': {
        key: 'noGoArea',
        title: 'No-go Areas',
        subtitle: 'Unauthorized presence',
        icon: <AiOutlineStop />,
        iconBgColor: '#FFE4E6',
        iconColor: '#DC2626'
    },
    'Door_Opened': {
        key: 'doorOpened',
        title: 'Open Gate',
        subtitle: 'security gate status',
        icon: <LuShield />,
        iconBgColor: '#FEF3C7',
        iconColor: '#F59E0B'
    },
    'Door_Closed': {
        key: 'doorClosed',
        title: 'Close Gate',
        subtitle: 'All models operational',
        icon: <LuShield />,
        iconBgColor: '#D1FAE5',
        iconColor: '#10B981'
    },
    'Helmet': {
        key: 'helmet',
        title: 'Helmet',
        subtitle: 'compliance violations',
        icon: <FaHardHat />,
        iconBgColor: '#E0E7FF',
        iconColor: '#6366F1'
    },
    'Vest': {
        key: 'vest',
        title: 'Vest',
        subtitle: 'compliance violations',
        icon: < FaVest/>,
        iconBgColor: '#E0E7FF',
        iconColor: '#6366F1'
    },
    'House_Keeping': {
        key: 'houseKeeping',
        title: 'House Keeping',
        subtitle: 'violations detected',
        icon: <MdMonitor />,
        iconBgColor: '#DBEAFE',
        iconColor: '#3B82F6'
    }
};

function LiveAlertSE() {
    const [subAreas, setSubareas] = useState([]);
    const [callApi, setCallApi] = useState(false);
    const [userData, setuserData] = useState(JSON.parse(localStorage.getItem('userData')))
    const [loading, setloading] = useState(true)
    const [cardsData, setcardsData] = useState([]);
    const [apiLoading, setApiLoading] = useState(false);

    // Helper function to get current week
    const getCurrentWeek = () => {
        const now = new Date();
        const oneJan = new Date(now.getFullYear(), 0, 1);
        const dayOfWeek = oneJan.getDay();
        const firstMondayOffset = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
        const firstMonday = new Date(oneJan.setDate(oneJan.getDate() + firstMondayOffset));
        const daysSinceFirstMonday = Math.floor((now - firstMonday) / 86400000);
        const weekNumber = Math.ceil((daysSinceFirstMonday + 1) / 7);
        return `${now.getFullYear()}-W${weekNumber.toString().padStart(2, "0")}`;
    };

    // Initialize filters state
    const [filters, setFilters] = useState(() => {
        const savedFilters = localStorage.getItem(FILTER_STORAGE_KEY);
        return savedFilters ? JSON.parse(savedFilters) : {
            customEndDate: "",
            customStartDate: "",
            date: '',
            filter: "",
            module: "",
            month: "",
            multiShift: [],
            severity: "",
            shift: [],
            subarea: [],
            timeFilterSelection: "week",
            week: getCurrentWeek(),
        };
    });

    // Fetch factories for sub areas
    const fetchFactories = () => {
        FactoryService.getAllFactories()
            .then((res) => {
                setSubareas(res.data?.data[0]?.areas?.[0]);
            })
            .catch((e) => {
                console.error("Error fetching factories:", e);
            });
    };

    // Create payload based on filters
    const createPayload = () => {
        const basePayload = {
            factory_id: userData.factory.id,
            client_id: userData.client.id,
            product_id: userData.product?.id || 1,
            shift_ids: Array.isArray(filters.shift) ? filters.shift : [],
        };

        // Determine filters based on time selection
        let dateFilters = {};

        if (filters.timeFilterSelection === 'week') {
            dateFilters = {
                week: filters.week || getCurrentWeek(),
                date: "",
                month: "",
                starting: "",
                ending: ""
            };
        } else if (filters.timeFilterSelection === 'month') {
            dateFilters = {
                week: "",
                date: "",
                month: filters.month || "",
                starting: "",
                ending: ""
            };
        } else if (filters.timeFilterSelection === 'daily') {
            dateFilters = {
                week: "",
                date: filters.date || "",
                month: "",
                starting: "",
                ending: ""
            };
        } else if (filters.timeFilterSelection === 'custom') {
            dateFilters = {
                week: "",
                date: "",
                month: "",
                starting: filters.customStartDate || "",
                ending: filters.customEndDate || ""
            };
        } else {
            // Default to week
            dateFilters = {
                week: getCurrentWeek(),
                date: "",
                month: "",
                starting: "",
                ending: ""
            };
        }

        return {
            ...basePayload,
            filters: {
                ...dateFilters,
                area_ids: Array.isArray(filters.subarea) ? filters.subarea : []
            }
        };
    };

    // Fetch module-wise alerts data
    const fetchModuleWiseAlerts = async () => {
        setApiLoading(true);
        try {
            const payload = createPayload();
            const response = await AreaService.moduleWiseAlerts(payload);
            
            if (response.data && response.data.totalAlertsChart) {
                const mappedCards = response.data.totalAlertsChart.map(alert => {
                    const mapping = CATEGORY_MAPPING[alert.category];
                    if (mapping) {
                        return {
                            ...mapping,
                            mainValue: alert.value.toString(),
                            subtitle: `${alert.value} ${mapping.subtitle}`,
                            severity: alert.severity
                        };
                    }
                    return null;
                }).filter(Boolean);

                // Order cards in desired sequence
                const orderedCards = [
                    'noGoArea', 'doorOpened', 'doorClosed', 
                    'helmet', 'vest', 'houseKeeping'
                ].map(key => mappedCards.find(card => card.key === key))
                 .filter(Boolean);

                setcardsData(orderedCards);
            }
        } catch (error) {
            console.error("Error fetching module-wise alerts:", error);
            errorToast("Failed to fetch alerts data");
        } finally {
            setApiLoading(false);
        }
    };

    // Load all data
    const loadAllData = () => {
        setloading(true);
        fetchModuleWiseAlerts();
        setTimeout(() => {
            setloading(false);
        }, 1000);
    };

    // Initial load
    useEffect(() => {
        fetchFactories();
    }, []);

    // Load data when filters change or component mounts
    useEffect(() => {
        loadAllData();
    }, [callApi]);

    // Filter handlers
    const handleAccept = (payload1) => {
        const processedFilters = {
            ...payload1,
            shift: payload1.shift || [],
            acknowledge: payload1.acknowledge === "Acknowledged" ? "true" : ""
        };

        localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(processedFilters));
        setFilters(processedFilters);
        setCallApi(!callApi);
    };

    const handleReset = async () => {
        const emptyFilters = {
            customEndDate: "",
            customStartDate: "",
            date: "",
            filter: "",
            module: "",
            month: "",
            multiShift: [],
            severity: "",
            shift: [],
            subarea: [],
            timeFilterSelection: "week",
            week: getCurrentWeek(),
            acknowledge: "",
        };

        localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(emptyFilters));
        setFilters(emptyFilters);
        setCallApi(!callApi);
    };

    console.log("set Filters:", filters);

    return (
        <div className="pt-4">
            <WeekFilterProvider>
                <ModelAnalyticsHeader
                    heading={`Live Alerts`}
                    currentWeek={false}
                    shifts={true}
                    multiShift={false}
                    months={false}
                    modules={false}
                    severity={false}
                    timeFilterOption={true}
                    areas={true}
                    acknowledge={false}
                    showActions={true}
                    onAccept={handleAccept}
                    onReset={handleReset}
                    subAreas={["subAreas"]}
                    setFilters={setFilters}
                    filters={filters}
                    FILTER_STORAGE_KEY={FILTER_STORAGE_KEY}
                />
                {
                    loading || apiLoading ? (
                        <div className="py-5">
                            <Loader3 />
                        </div>
                    ) : (
                        <>
                            <Row>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h2 style={{
                                        fontSize: "28px",
                                        fontWeight: "700",
                                        color: "#091954",
                                        margin: "0",
                                        textAlign: "center"
                                    }}>
                                        Module-wise Alerts Overview
                                    </h2>
                                </div>
                                {cardsData.length > 0 ? (
                                    cardsData.map((card, index) => (
                                        <Col key={index} xl="4" lg="4" md="6" sm="12" className="mb-3">
                                            <InfoCardsV2
                                                title={card.title}
                                                mainValue={card.mainValue}
                                                subtitle={card.subtitle}
                                                icon={card.icon}
                                                iconBgColor={card.iconBgColor}
                                                iconColor={card.iconColor}
                                            />
                                        </Col>
                                    ))
                                ) : (
                                    <Col className="text-center py-5">
                                        <p style={{ color: "#6B7280", fontSize: "16px" }}>
                                            No alerts data available for the selected filters
                                        </p>
                                    </Col>
                                )}
                                <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
                                    <h2 style={{
                                        fontSize: "28px",
                                        fontWeight: "700",
                                        color: "#091954",
                                        margin: "0",
                                        textAlign: "center"
                                    }}>
                                        Detailed Alerts
                                    </h2>
                                </div>
                                <Row>
                                <NoGoAlert filter={filters} title={'No-go Areas Alerts'} />
                            </Row>
                            <Row>
                                <HouseKeeping filter={filters} title={'House Keeping Alerts'} />
                            </Row>
                            <Row>
                                <Vest filter={filters} title={'Vest Alerts'} />
                            </Row>
                            <Row>
                                <HelmetModule filter={filters} title={'Helmet Alerts'} />
                            </Row>
                            {/* <Row className="mt-4 mb-4">
                                <Col lg={8}>
                                    <GateOpenAlert />
                                </Col>
                                <Col lg={4}>
                                    <FireAlert />
                                </Col>
                            </Row> */}
                            </Row>
                        </>
                    )
                }
            </WeekFilterProvider>
        </div>
    )
}

export default LiveAlertSE;